import { Fragment } from "react";
import SelectInput from "../components/common-components/SelectInput";
import Calendar from "./calendar/Calendar";
import { InputWithToolTip } from "./InputWithToolTip";

const FillDataInput = ({
    getValueFunc,
    inputValue,
    className,
    inputType,
    optionsList,
    optionName,
    defaultText,
    isDarkMode
}) => {
    const COMPONENTS = {
        Text: (
            <Fragment>
                <InputWithToolTip
                    wrapper={{
                        className: `trade_inputs tool-tip-container z-6 ${className}`
                    }}
                    span={{
                        className: "tool-tip",
                        placeholder: inputValue.placeholder
                    }}
                    input={{
                        type: "number",
                        value: inputValue.value,
                        className: `singleInput ${
                            isDarkMode ? "bg-secondaryDark" : "bg-secondaryLight"
                        }`,
                        onChange: (e) => getValueFunc(e.target.value)
                    }}
                />
            </Fragment>
        ),
        Date: <Fragment></Fragment>,
        Select: (
            <Fragment>
                <SelectInput
                    selectFunction={(value) => getValueFunc(value)}
                    selectHolder={{
                        minWidth: 150,
                        // background: "red",
                        display: "flex",
                        minHeight: 30,
                        margin: "10px 0",
                        padding: "0 10px",
                        zIndex: 15
                    }}
                    selectOptions={{
                        holderStyle: {
                            flex: 1,
                            display: "flex",
                            justifyContent: "center",
                            position: "relative"
                        },
                        selectedValue: {
                            defaultText,
                            style: {
                                background: isDarkMode ? "#8D99AE" : "#DEE2FF",
                                width: "50%",
                                margin: "10px 0",
                                minWidth: 150,
                                minHeight: 32,
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                cursor: "pointer",
                                fontSize: 10,
                                zIndex: 15,
                                border: "1px solid #fff"
                            }
                        },
                        list: {
                            holderStyle: {
                                position: "absolute",
                                top: 45,
                                zIndex: 20
                            },
                            options: Object.values(optionsList || []),
                            singleOption: {
                                divStyle: {
                                    background: isDarkMode ? "#8D99AE" : "#DEE2FF",
                                    minWidth: 150,
                                    width: "100%",
                                    marginTop: 5,
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    minHeight: 30,
                                    zIndex: 20,
                                    border: "1px solid #fff",
                                    boxShadow: "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
                                    cursor: "pointer"
                                },
                                labelStyle: {
                                    cursor: "pointer",
                                    fontSize: 10,
                                    zIndex: 20
                                },
                                inputStyle: {
                                    display: "none"
                                }
                            }
                        }
                    }}
                    optionName={optionName}
                    isEditable={true}
                />
            </Fragment>
        )
    };
    return COMPONENTS[inputType];
};

export default FillDataInput;
